// Save the current URL so user returns to the same page after login
const earlyUrl = window.location.pathname + window.location.search;
sessionStorage.setItem('redirect_back_url', earlyUrl);
// console.log('EARLIEST URL CAPTURE:', earlyUrl);
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
